import React, { Component } from "react";

import trash from "views/profile/img/delete-2.svg";
import edit from "views/profile/img/edit.svg";
import instagram from "views/profile/img/social/instagram.png";
import twitter from "views/profile/img/social/twitter.png";
import googleplus from "views/profile/img/social/googleplus.png";
import facebook from "views/profile/img/social/facebook.png";
import linkedin from "views/profile/img/social/linkedin.png";
import pinxt from "views/profile/img/social/pinxt.png";
class Social extends Component {
  render() {
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5  mt-2">
        <div className=" lg:px-12 md:px-12 pb-6">
          <p className="text898989 fsize14">Add your social media Accounts</p>

          <div className="mt-8 lg:flex  md:flex">
            <div className="lg:w-1/2 md:w-1/2 w-full">
              <div className="lg:w-3/4 md:w-3/4 w-full">
                <div className="flex justify-between items-center mb-8">
                  <div className="flex items-center">
                    <img
                      src={instagram}
                      alt="instagram"
                      className="w-42px h-42px"
                    />
                    <p className="fsize16 text-black ml-4">
                      Instagram/qwertyuio
                    </p>
                  </div>

                  <div className="flex items-center">
                    <img src={trash} alt="trash" className="w-5 h-5 mr-3" />
                    <img
                      src={edit}
                      alt="edit"
                      className="text053C6D w-5 h-5 "
                    />
                  </div>
                </div>

                <div className="flex justify-between items-center mb-8">
                  <div className="flex items-center w-full">
                    <img
                      src={linkedin}
                      alt="linkedin"
                      className="w-42px h-42px"
                    />
                    <div class="form-group w-full modal-form-cs ml-4">
                      <input
                        type="text"
                        placeholder=""
                        className="fsize16"
                        value="Linkedin/qwertyuio"
                      />
                    </div>
                  </div>{" "}
                  <div className="ml-2">
                    <button className="sm-outlinebutton w-120px font-bold fsize12 h-40px uppercase">
                      SUBMIT
                    </button>
                  </div>
                </div>
                <div className="flex items-center mb-8">
                  <img
                    src={googleplus}
                    alt="googleplus"
                    className="w-42px h-42px"
                  />
                  <div class="form-group w-full modal-form-cs ml-4">
                    <input
                      type="text"
                      placeholder=""
                      className="fsize16"
                      value="Paste Url here"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2 md:w-1/2 w-full">
              {" "}
              <div className="lg:w-3/4 md:w-3/4 w-full">
                <div className="flex items-center mb-8">
                  <img
                    src={twitter}
                    alt="instagram"
                    className="w-42px h-42px"
                  />
                  <div class="form-group w-full modal-form-cs ml-4">
                    <input
                      type="text"
                      placeholder=""
                      className="fsize16"
                      value="Paste Url here"
                    />
                  </div>
                </div>
                <div className="flex items-center mb-8">
                  <img
                    src={facebook}
                    alt="instagram"
                    className="w-42px h-42px"
                  />
                  <div class="form-group w-full modal-form-cs ml-4">
                    <input
                      type="text"
                      placeholder=""
                      className="fsize16"
                      value="Paste Url here"
                    />
                  </div>
                </div>
                <div className="flex items-center mb-8">
                  <img src={pinxt} alt="instagram" className="w-42px h-42px" />
                  <div class="form-group w-full modal-form-cs ml-4">
                    <input
                      type="text"
                      placeholder=""
                      className="fsize16"
                      value="Paste Url here"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card>
    );
  }
}
export default Social;
